import type { FC, PropsWithChildren } from 'react';

import { AccessContext } from './access-context';

const value = { hasTimeSeriesRwAccess: true };

export const CdmAccessProvider: FC<PropsWithChildren> = ({ children }) => {
  // TODO [FO-2787]: Implement actual read/write access check based on spaces.
  // Until then, this temporary provider always grants access.
  return (
    <AccessContext.Provider value={value}>{children}</AccessContext.Provider>
  );
};
